import { Link } from 'react-router-dom';

export default function TestimonialSection() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="px-4 md:px-6 max-w-6xl mx-auto relative">
        <div className="bg-foreground-950 rounded-2xl overflow-hidden flex flex-col lg:flex-row">
          <div className="lg:w-[40%] relative overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Stylish%20modern%20professional%20sitting%20in%20bright%20airy%20home%20office%20with%20large%20monstera%20plant%20behind%2C%20wearing%20casual%20linen%20shirt%2C%20working%20on%20laptop%20with%20genuine%20smile%2C%20warm%20natural%20sunlight%20through%20floor%20to%20ceiling%20windows%2C%20cream%20walls%20with%20abstract%20art%20print%2C%20authentic%20lifestyle%20portrait%20photography%2C%20relaxed%20confident%20expression&width=600&height=700&seq=testimonial-v2&orientation=portrait"
              alt="Mulebuy spreadsheet user experience"
              className="w-full h-full object-cover min-h-[300px] lg:min-h-[500px]"
              title="Mulebuy Spreadsheet User"
            />
          </div>

          <div className="lg:w-[60%] flex flex-col justify-center p-8 md:p-12 lg:p-16">
            <span className="text-6xl md:text-7xl font-heading text-accent-300 leading-none mb-6">
              &ldquo;
            </span>

            <p className="text-lg md:text-xl text-white leading-relaxed mb-8">
              The mulebuy spreadsheet system completely changed how I shop online. I can now compare hundreds of products in minutes, track every order effortlessly, and the pricing transparency means I never overpay. It is the most efficient mulebuy spreadsheet tool I have found.
            </p>

            <div className="mb-8">
              <p className="text-sm font-semibold text-white">Alex Chen</p>
              <p className="text-xs text-foreground-400 mt-1">Regular Mulebuy Spreadsheet User</p>
            </div>

            <Link
              to="/mulebuy-spreadsheet-complete-guide"
              className="inline-flex items-center px-6 py-3 bg-accent-200/80 text-foreground-950 rounded-full font-semibold text-sm hover:bg-accent-300/80 transition-all whitespace-nowrap cursor-pointer w-fit"
            >
              Read Success Stories
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}